import { useEffect, useState } from "react";

export default function useScrollbar() {
  const [showScrollbar, setShowScrollbar] = useState(false);

  useEffect(() => {
    if (showScrollbar) {
      document.body.style.overflowY = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100vw";
    } else {
      document.body.style.overflowY = "auto";
      document.body.style.position = "";
      document.body.style.width = "";
    }
    return () => {
      document.body.style.overflowY = "auto";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, [showScrollbar]);

  return [showScrollbar, setShowScrollbar];
}
